import * as React from 'react';
import { Select, Option } from '@cian/ui-kit/prev';
import { Label } from './Label';
import { useFormikContext, Field } from 'formik';
import { IFormValues } from '../DealRentModal';
import { useFieldHasErrors } from './utils';
import * as styles from '../index.css';

const options = ['Семья', 'Пара', 'Несколько семей'];

export const PersonsDescription = () => {
  const { setFieldValue } = useFormikContext<IFormValues>();
  const invalid = useFieldHasErrors('personsInfo');
  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>, value: string) => setFieldValue('personsInfo', value),
    [setFieldValue],
  );

  return (
    <div className={styles['field']}>
      <Label invalid={invalid}>Состав проживающих</Label>
      <Field placeholder="Выбрать" as={Select} onChange={onChange} name="personsInfo" custom={{ invalid }}>
        {options.map(value => (
          <Option key={value} value={value}>
            {value}
          </Option>
        ))}
      </Field>
    </div>
  );
};
